import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TbOnlyNumberDirective } from './directives/only-number.directive';
import { TBOnlyLetterDirective } from './directives/only-letter.directive';
import { AutoFocusDirective } from './directives/auto-focus-directive';
import { MessageComponent } from './message/message.component';
import { NzAlertModule } from 'ng-zorro-antd';
import { CardFormat } from './pipes/card-format';
import { InputRestrictionDirectiveDirective } from './directives/input-restriction-directive.directive';
import { PaymentTypePipe } from './pipes/payment-type.pipe';
import { N11AmountPipe } from './pipes/n11-amount.pipe';
import { AmountPipe } from './pipes/amount.pipe';
import { SafePipe } from './pipes/safe.pipe';

const DECLARATIONS_AND_EXPORT = [
  TbOnlyNumberDirective,
  TBOnlyLetterDirective,
  AutoFocusDirective,
  InputRestrictionDirectiveDirective,
  MessageComponent,
  CardFormat,
  PaymentTypePipe,
  N11AmountPipe,
  AmountPipe,
  SafePipe
];

@NgModule({
  declarations: [...DECLARATIONS_AND_EXPORT],
  imports: [
    CommonModule,
    NzAlertModule
  ],
  exports: [...DECLARATIONS_AND_EXPORT]
})
export class SharedCommonModule {
}
